// @ts-nocheck
// cursor: disable-autocomplete
export default {
  'landing.title': 'Bienvenue sur ColQuest',
  common: {
    backToHome: '← Retour à l\'accueil',
    copyright: '© 2025 ColQuest. Augustin Lafanechere. Tous droits réservés.',
    loading: 'Chargement...',
    price: 'Disponible dans les App Stores\nPrintemps 2025',
    joinWaitlist: {
      line1: '🏔️ Rejoignez l\'aventure 🚴‍♂️',
      line2: 'Lancement Printemps 2025'
    },
    privacyPolicy: 'Politique de confidentialité',
    contact: 'Nous Contacter',
    submitSummit: 'Proposer un sommet'
  },
  menu: {
    title: 'Menu',
    download: 'Télécharger ColQuest',
    mapper: 'ColQuest Mapper',
    reachOut: 'Contactez-nous',
    language: 'Langue'
  },
  landing: {
    title: 'ColQuest',
    cta: 'Télécharger',
    subtitle: 'Faisons grandir votre Col•lection',
    release: {
      coming: 'Disponible au Printemps 2025',
      date: 'Rejoignez la liste d\'attente pour un accès anticipé',
    },
    roadmap: {
      title: 'Feuille de route',
      current: {
        title: 'Au lancement',
        features: [
          'Applications iOS et Android',
          'Synchronisation avec Strava',
          'Suivi et découverte des cols',
          'Score et classement personnel',
          'Quêtes et défis régionaux',
        ] as string[],
      },
      future: {
        title: 'À Venir',
        features: [
          'Types de cols additionnels',
          'Cols non goudronnés',
          'Intégrations Garmin et autres plateformes',
          'Classements mondiaux et régionaux',
          'Fonctionnalités sociales et succès',
        ] as string[],
      }
    },
    waitlist: {
      title: 'Rejoignez la Liste d\'Attente',
      description: 'Soyez parmi les premiers à essayer ColQuest !\nEn rejoignant notre liste d\'attente, vous :\n• Obtiendrez un accès anticipé lors du lancement dans votre pays\n• Recevrez des mises à jour exclusives sur le développement',
      placeholder: 'Entrez votre email',
      emailLabel: 'Adresse Email',
      platformLabel: 'Plateforme Préférée',
      countryLabel: 'Votre Pays',
      otherCountryPlaceholder: 'Veuillez préciser votre pays',
      button: 'Rejoindre la Liste',
      success: 'Merci de votre inscription ! Nous vous contacterons dès que ColQuest sera disponible dans votre pays.',
      error: 'Désolé, une erreur s\'est produite lors de l\'inscription. Veuillez réessayer.',
    },
    appStores: {
      title: 'Télécharger Maintenant',
      appStore: 'Télécharger sur l\'App Store',
      playStore: 'Obtenir sur Google Play',
    },
    download: {
      title: 'Télécharger ColQuest',
      subtitle: 'Faites grandir votre col•lection dès maintenant\u00A0!',
      appStore: 'Télécharger sur l\'App Store',
      playStore: 'Télécharger sur Google Play',
      androidPreview: 'Rejoindre la Preview Android',
      join: "Rejoindre"
    },
    androidPreview: {
      title: 'Devenez Bêta-testeur',
      description: 'Si vous souhaitez essayer ColQuest et nous aider à finaliser sa sortie officielle, vous pouvez rejoindre notre équipe de testeurs.\n\nSi vous achetez une souscription elle restera valable pour les versions futures.',
      emailLabel: 'Adresse Email',
      emailPlaceholder: 'Entrez votre email',
      submit: 'C\'est parti\u00A0!',
      error: 'Échec de l\'envoi de la demande. Veuillez réessayer.',
      success: {
        title: '👀 Surveillez votre boîte mail ! 📬',
        message: 'Notre équipe vous contactera personnellement dans les plus brefs délais pour vous envoyer les instructions d\'installation de notre version bêta.'
      }
    },
    features: {
      title: 'Fonctionnalités',
      summitTracking: {
        title: 'Suivez Vos Cols',
        description: 'Détectez et enregistrez automatiquement chaque col et sommet conquis lors de vos sorties.',
      },
      scoringClimbs: {
        title: 'Marquez des Points',
        description: 'Gagnez des points selon la difficulté, le dénivelé et vos nouvelles découvertes',
      },
      quests: {
        title: 'Quêtes Épiques',
        description: 'Complétez des quêtes régionales pour gagner des points supplémentaires et donner un sens à vos sorties.',
      },
    },
    hero: {
      title: 'Partez à la chasse aux cols\u00A0!',
      description: 'Faites grandir votre col•lection avec ColQuest. Chaque ascension compte : cumulez des points, complétez des quêtes, un col après l’autre.',
    },
    howItWorks: {
      title: 'Comment ça marche\u00A0?',
      step1: {
        title: 'Installez l\'application',
        description: 'Connectez votre compte **Strava** ou **Garmin**. ColQuest chargera vos activités pour construire votre **col•lection**, calculer votre score et votre progression dans les quêtes.'
      },
      step2: {
        title: 'Chassez des cols',
        description: 'Après chaque ascension, ColQuest **détectera automatiquement les cols franchis** depuis votre activité. Le **score** sera calculé en fonction de la **difficulté** de l\'ascension, avec des **bonus de découverte** ou de **rareté**.'
      },
      step3: {
        title: 'Terminez des quêtes',
        description: 'Les cols sont répartis dans des **quêtes**. Terminez-les pour obtenir des points supplémentaires et grimper au **classement**.'
      },
      faqText: 'Envie d\'en savoir plus\u00A0?',
      faqButton: 'Consultez notre FAQ'
    },
    stats: {
      summits: 'Cols',
      quests: 'Quêtes',
      countries: 'Pays',
      submitSummitText: 'Vous pensez qu\'il nous manque un col\u00A0?',
      submitSummitButton: 'Soumettre un col'
    },
    reachOut: {
      title: 'Contactez-nous',
      instagram: 'Instagram',
      strava: 'Strava',
      email: 'Email'
    },
  },
  faq: {
    title: 'Foire aux Questions',
    questions: {
      what: {
        question: 'Qu\'est-ce que ColQuest\u00A0?',
        answer: 'ColQuest est une application mobile (iOS et Android) pour les cyclistes amoureux de dénivelé positif. Elle analyse vos activités depuis Strava ou Garmin pour suivre les cols que vous avez conquis. Chaque ascension vous permet de remporter des points et de grimper au classement. Les cols sont regroupés au sein de quêtes qui vous permettent de gagner des points supplémentaires quand vous parvenez à les terminer',
      },
      pricing: {
        question: 'Est-ce que ColQuest est payant\u00A0?',
        answer: 'L\'inscription est gratuite.\nL\'accès à votre score global, au classement et aux statistiques de vos futures activités est payant, pour 34,99€ par an, 12,99€ par mois ou 8,99€ par semaine.',
      },
      summitSelection: {
        question: 'Comment sont sélectionnés les cols\u00A0?',
        answer: 'Les cols proviennent de la base de données Open Street Map ou sont proposés par nos utilistateurs.\nN\'hésitez pas à nous suggérer des cols <link>via ce formulaire</link> !',
      },
      summitDetection: {
        question: 'Comment sont identifiés les cols sur une activités\u00A0?',
        answer: 'Nous comparons la trace GPS de votre activité aux coordonnées des cols de la base ColQuest. Si votre trace est à moins de 200 mètres d\'un col ce col est considéré comme franchi.',
      },
      scoring: {
        question: 'Comment est défini le score pour un col\u00A0?',
        answer: 'Nous identifions la route empruntée pour l\'ascension, calculons sa pente et sa longueur. Ces deux paramètres donnent un score initial de difficulté. Il est ensuite bonifié selon la rareté du sommet et si c\'est la première fois que vous le franchissez. Si vous finalisez une quête vous obtiendrez 1000 points bonus par cols présents dans la quête.',
      },
      import: {
        question: 'Est-ce que je peux importer mes activités?',
        answer: 'Nous supportons l\'import automatique d\'activités Strava ou Garmin. Votre historique est chargé au moment de l\'inscription. Nous souhaitons à terme aussi permettre l\'import manuel de fichiers GPX directement dans l\'application.',
      },
      rarety: {
        question: 'Comment est défini la rareté d\'un col\u00A0?',
        answer: 'Nous analysons quotidiennement les ascensions de chaque col par chaque utilisateur et déterminons ainsi la popularité de chaque col. Moins un col a été grimpé par les utilisateurs ColQuest, plus il est rare. Nous ferons évoluer les seuils de rareté en fonction du nombre d\'utilisateurs sur ColQuest.'
      },
      privacy: {
        question: 'Comment gérez-vous mes données\u00A0?',
        answer: 'Nous collectons uniquement les données d\'activité partagées par Strava ou Garmin lorsque vous connectez votre compte. Ces données sont exclusivement utilisées pour alimenter les fonctionnalités du jeu ColQuest (détection des cols, calcul des scores, etc.).\n\nVos données et activités restent privées et ne sont pas partagées avec les autres utilisateurs. Vous pouvez choisir l\'affichage de votre nom d\'utilisateur au sein du classement global.\n\nPour plus de détails,  notre <privacy>politique de confidentialité</privacy>.'
      }
    },
  },
  privacy: {
    title: 'Politique de Confidentialité',
    intro: {
      title: 'Introduction',
      content: 'Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre application mobile.',
    },
    collection: {
      title: 'Informations que nous collectons',
      personal: {
        title: 'Informations que vous nous fournissez',
        intro: 'Nous collectons les informations que vous nous fournissez directement, notamment :',
        items: [
          'Adresse email',
          'Pays, ville, langue',
          'Nom d\'utilisateur',
          'Les données d\'activité et leurs tracés importées depuis Strava ou Garmin',
        ],
      },
      usage: {
        title: 'Informations que nous collectons automatiquement',
        intro: 'Nous collectons automatiquement certaines informations sur votre appareil et votre interaction avec notre application :',
        items: [
          'Informations sur l\'appareil (modèle, système d\'exploitation, etc.)',
          'Informations de connexion',
        ],
      },
    },
    usage: {
      title: 'Utilisation de vos données',
      intro: 'Nous utilisons les données collectées pour :',
      items: [
        'Suivre les cols que vous avez franchi',
        'Calculer vos scores et votre classement',
        'Recommander des quêtes',
        'Améliorer la détection des cols',
        'Améliorer l\'expérience de jeu',
      ],
    },
    security: {
      title: 'Sécurité des données',
      content: 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations personnelles contre l\'accès, la modification, la divulgation ou la destruction non autorisés.',
    },
    retention: {
      title: 'Conservation des données',
      intro: 'Nous stockons et conservons les données des utilisateurs. Nous conservons vos données personnelles tant que votre compte ColQuest reste actif, car ces données sont nécessaires au fonctionnement de l\'application (détection des cols, calcul des scores et classements, recommandation de quêtes et amélioration de l\'expérience). Tant que votre compte est actif, nous conservons :',
      items: [
        'Les informations de compte (adresse email, nom d\'utilisateur, pays, ville, langue)',
        'Les données d\'activité et leurs tracés importés depuis Strava ou Garmin',
        'Les informations sur l\'appareil et de connexion collectées automatiquement',
        'Les événements d\'analyse associés à votre compte',
      ],
      deletion: 'Lorsque vous supprimez votre compte depuis l\'application, nous supprimons votre compte et les données personnelles associées de nos systèmes actifs. Si vous demandez la suppression via notre site web, nous traitons la demande après vérification de votre identité, généralement sous 1 à 2 jours ouvrables, et dans tous les cas sous 30 jours.',
      backups: 'Après la suppression du compte, nous ne conservons pas vos données personnelles, sauf lorsque nous devons retenir des informations limitées pendant une courte période pour des raisons de sécurité, de prévention de la fraude ou d\'obligations légales (par exemple, des sauvegardes chiffrées écrasées de manière rotative). Ces copies résiduelles sont supprimées selon notre rotation de sauvegardes, généralement sous 90 jours. Nous ne vendons pas vos données personnelles.',
    },
    contact: {
      title: 'Nous contacter',
      content: 'Si vous avez des questions sur cette politique de confidentialité, veuillez nous contacter à : ',
    },
    lastUpdated: 'Dernière mise à jour : Août 2026',
    deletion: {
      title: 'Suppression de compte',
      content: 'Vous avez le droit de demander la suppression de vos données personnelles. À réception de votre demande, nous vérifierons votre identité et procéderons à la suppression de votre compte et des données associées.',
      link: 'Demander la Suppression du Compte'
    },
  },
  account_deletion: {
    title: "Demande de Suppression de Compte",
    warning: "Attention : La suppression du compte est permanente et ne peut pas être annulée. Toutes vos données seront définitivement supprimées de nos systèmes.",
    email_label: "Votre Adresse Email",
    email_placeholder: "Entrez votre adresse email",
    submit_button: "Demander la Suppression",
    error: {
      invalid_email: "Veuillez entrer une adresse email valide",
      submission_failed: "Échec de l'envoi de la demande. Veuillez réessayer.",
      already_requested: "Une demande de suppression existe déjà pour cet email"
    },
    success: {
      title: "Demande Reçue",
      message: "Nous avons reçu votre demande de suppression de compte. Notre équipe vous contactera à l'adresse email fournie pour confirmer votre propriété et traiter la demande de suppression. Cela prend généralement 1 à 2 jours ouvrables."
    }
  },
  summit_submission: {
    title: 'Proposer un col',
    description: 'Aidez-nous à enrichir la base de données ColQuest en suggérant de nouveaux cols ! Notre équipe examinera votre proposition et pourra vous contacter pour obtenir des informations complémentaires afin de s\'assurer que le col correspond à nos critères.',
    form: {
      name: {
        label: 'Nom du col *',
        placeholder: 'ex: Col du Galibier'
      },
      coordinates: {
        title: 'Localisation du col *',
        latitude: {
          label: 'Latitude *',
          placeholder: 'ex: 45.0633'
        },
        longitude: {
          label: 'Longitude *',
          placeholder: 'ex: 6.4083'
        }
      },
      email: {
        label: 'Votre Adresse Email *',
        placeholder: 'Nous pourrons vous contacter pour plus de détails',
        validation: "Veuillez entrer une adresse e-mail valide (ex: nom@exemple.com)"
      },
      details: {
        label: 'Détails Supplémentaires (optionnel)',
        placeholder: 'Parlez-nous de ce col ! Pourquoi devrait-il être ajouté à ColQuest\u00A0? Incluez toute information pertinente sur l\'accessibilité, l\'état des routes ou l\'importance historique.'
      },
      submit: 'Proposer le col'
    },
    success: {
      title: 'Col proposé ! 🏔️',
      message: 'Merci pour votre contribution ! Notre équipe examinera votre proposition et vous contactera si nous avons besoin d\'informations supplémentaires.'
    },
    error: {
      invalidEmail: "Veuillez entrer une adresse e-mail valide",
      submission: "Une erreur s'est produite lors de la soumission du col. Veuillez réessayer."
    }
  },
  android_banner: {
    title: 'Télécharger ColQuest',
    subtitle: 'Obtenez l\'application sur Google Play',
    download: 'Télécharger',
    install: 'Je l\'ai déjà',
    close_aria: 'Fermer la bannière'
  },
  events: {
    loading: 'Chargement de l\'événement...',
    error: {
      title: 'Erreur lors du chargement de l\'événement'
    },
    notFound: {
      title: 'Événement introuvable',
      message: 'L\'événement que vous recherchez n\'existe pas.'
    },
    hero: {
      registerNow: 'S\'inscrire maintenant'
    },
    summits: {
      title: 'Les Cols',
      intro: 'Cette route comprend {{count}} col{{plural}} avec un score total de {{totalScore}} points.',
      points: 'pts',
      bonus: 'bonus'
    },
    description: {
      title: 'Description'
    },
    routeOverview: {
      title: 'Détails',
      distance: 'km',
      elevation: 'm',
      totalDistance: 'Distance Totale',
      elevationGain: 'Dénivelé Positif',
      minimumScore: 'Score ColQuest Minimum',
      cols: 'Cols'
    },
    routeVisualization: {
      title: 'La Carte'
    }
  },
  premium: {
    title: '✨ ColQuest Premium',
    subtitle: 'Débloquez toutes les fonctionnalités premium',
    featuresTitle: 'Inclus dans Premium',
    features: [
      'Scan automatique de toutes vos futures activités',
      'Extension de planification d\'itinéraires pour Strava & Komoot'
    ],
    price: '12,99€',
    priceFrequency: '/an',
    cancelAnytime: 'Résiliez à tout moment',
    subscribeButton: 'S\'abonner à Premium',
    processing: 'Traitement...',
    noUserIdError: 'Aucun ID utilisateur fourni. Veuillez vous connecter d\'abord.',
    checkoutError: 'Échec du démarrage du paiement',
    successTitle: 'Bienvenue dans Premium !',
    successMessage: 'Votre abonnement a été activé avec succès.',
    extensionBenefit: 'Vous pouvez maintenant utiliser toutes les fonctionnalités premium de l\'extension ColQuest Mapper',
    appBenefit: 'Votre abonnement premium fonctionne aussi sur l\'application mobile. Toutes vos futures ascensions seront automatiquement synchronisées.',
    downloadApp: 'Téléchargez l\'application ColQuest pour commencer votre aventure :',
    supportNote: 'Besoin d\'aide ? Contactez-nous à',
    extensionNote: 'Après le paiement, retournez à l\'extension pour voir vos fonctionnalités premium',
    plansTitle: 'Choisissez votre formule'
  },
  mapper: {
    title: 'ColQuest Mapper',
    beta: 'Bêta',
    tagline: 'Tracez vos plus belles ré•col•tes.',
    cta: 'Ajouter à Chrome',
    ctaNote: 'Un compte ColQuest premium est requis.',
    howItWorks: {
      title: 'Comment ça marche\u00A0?',
      step1: {
        title: 'Installez l\'extension',
        description: 'Ajoutez ColQuest Mapper à Chrome en un clic. Connectez-vous avec votre compte ColQuest.'
      },
      step2: {
        title: 'Planifiez votre itinéraire',
        description: 'Ouvrez le traceur d\'itinéraires Strava ou Komoot comme d\'habitude. Les cols apparaissent directement sur la carte.'
      },
      step3: {
        title: 'Maximisez votre col\u00B7lection',
        description: 'Ajustez votre tracé pour passer par un maximum de cols et marquer un max de points.'
      }
    },
    platforms: {
      title: 'Compatible avec vos outils',
      strava: 'Traceur Strava',
      komoot: 'Planificateur Komoot'
    },
    bottomCta: {
      title: 'Prêt à chasser les cols\u00A0?',
      subtitle: 'Planifiez des sorties plus malines dès aujourd\'hui.'
    }
  }
}; 